<template>
  <ButtonBack />
  <div class="page-operations">
    <Card />
    <div class="div-separator-64"></div>
    <CampaignList />
    <div class="div-separator-32"></div>
    <TransactionList />
  </div>
</template>

<script setup>
  import ButtonBack from "@/components/ButtonBack.vue";
  import Card from "@/components/Card/Card.vue";
  import CampaignList from "@/components/Campaign/CampaignList.vue";
  import TransactionList from "@/components/Transaction/TransactionList.vue";
  import {onMounted} from "vue";

  let startY = 0;
  let endY = 0;
  let isDragging = false;
  let startInModalContent = false;
  let originalModalPaddingHeight = null;
  let modalId = null;

  onMounted(async () => {
    document.addEventListener('touchstart', (e) => {
      startY = e.touches[0].clientY;
      isDragging = true;

      if (e.target.closest(".modal-transaction-resizer")) {
        modalId = e.target.closest(".transaction-modal").getAttribute("id");
        startInModalContent = true;
        originalModalPaddingHeight = e.target.closest(".transaction-modal-content").getElementsByClassName('transaction-modal-padding')[0].offsetHeight;
      }
    });

    document.addEventListener('touchmove', (e) => {
      if (isDragging && startInModalContent) {
        endY = e.touches[0].clientY;

        let newHeight = originalModalPaddingHeight - (endY - startY);

        if (newHeight < originalModalPaddingHeight && 0 < newHeight ) {
          e.target.closest(".transaction-modal-content").getElementsByClassName('transaction-modal-padding')[0].style.height = `${newHeight}px`;

          if (newHeight <= 2) {
            e.target.closest(".transaction-modal-content").getElementsByClassName('transaction-modal-amount')[0].style.display = 'none';
          } else {
            e.target.closest(".transaction-modal-content").getElementsByClassName('transaction-modal-amount')[0].style.display = 'block';
          }
        }
      }
    });

    document.addEventListener('touchend', (e) => {
      if (isDragging && startInModalContent) {
        if (endY >= startY) {
          // Hide modal
          document.getElementById(modalId).style.display = 'none';

          // Restore height
          document.getElementById(modalId).getElementsByClassName('transaction-modal-padding')[0].style.height = `${originalModalPaddingHeight}px`;

          document.getElementById(modalId).getElementsByClassName('transaction-modal-amount')[0].style.display = 'block';

          // Restore scroll
          document.body.style.overflowY = 'scroll';
        }
      }

      isDragging = false;
      startInModalContent = false;
      originalModalPaddingHeight = null;
      modalId = null;
    });
  });
</script>

<style scoped lang="scss">
  .page-operations {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
</style>